__turbopack_context__.v({
  "content": "styles-module-scss-module__TWBVKq__content",
  "content--full": "styles-module-scss-module__TWBVKq__content--full",
  "main": "styles-module-scss-module__TWBVKq__main",
});
